/**
 * API base URL used by axios/fetch (e.g. https://localhost:7202/api/).
 */
export function getApiBaseUrl() {
  return (process.env.REACT_APP_API_URL || "").replace(/\/+$/, "");
}

/**
 * API site origin without the /api suffix (e.g. https://localhost:7202).
 */
export function getApiOriginUrl() {
  const base = getApiBaseUrl();
  if (!base) return "";
  return base.replace(/\/api$/i, "");
}

/**
 * SignalR hub on API host root — NOT under /api/.
 * Correct:   https://localhost:7202/hubs/notification
 * Incorrect: https://localhost:7202/api/hubs/notification
 */
export function getNotificationHubUrl() {
  // const explicit = (process.env.REACT_APP_SIGNALR_HUB_URL || "").trim();
  // if (explicit) {
  //   return explicit.replace(/\/+$/, "").replace(/\/api\/hubs\//i, "/hubs/");
  // }

  // const origin = getApiOriginUrl();
  // if (!origin) {
  //   console.error(
  //     "[SignalR] Set REACT_APP_API_URL in .env (e.g. https://localhost:7202/api/).",
  //   );
  //   return "";
  // }

  return `${getApiBaseUrl()}/hubs/notification`;
}
